/**
 * Route for `advertiser-caps`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserCapsPage } from "../features/advertiser-caps/AdvertiserCapsPage";

export const advertiserCapsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-caps",
	component: AdvertiserCapsPage,
});

export default advertiserCapsRoute;
